(function () {
  "use strict";

  SeriesCtrl.$inject = ['$scope', '$rootScope', '$routeParams', 'authView', 'trackingService', '$location', 'tabUtil', 'resolveData', 'refreshSession', '$window', 'mtypes', 'notificationService', 'accountInfoService'];
  angular
    .module('trainerWebApp.controllers')
    .controller('SeriesCtrl', SeriesCtrl)
    .factory('tabUtil', tabUtil);

  function SeriesCtrl($scope, $rootScope, $routeParams, authView, trackingService, $location, tabUtil, resolveData,
                      refreshSession, $window, mtypes, notificationService, accountInfoService) {

    $window.document.title = "Course | Mindflash Training Management System";

    $scope.resolvedData = resolveData;
    $scope.tabs = authView.getTabs();

    $scope.contentSrc = '';
    $scope.currentTab = $routeParams;

    var queryParams = $location.search();

    $scope.montara = queryParams.series;

    $scope.$watch('currentTab', function (newValue) {
      var tab = tabUtil.getTab(newValue.tabName, $scope.tabs);
      if (!tab) {
        tab = $scope.tabs[0];
      }
      tabUtil.selectTab(tab, $scope.tabs);
      $scope.contentSrc = tab.contentSrc;
      $rootScope.page = tab;
    });

    $scope.trackTabVisible = authView.showGoodData();
    $scope.trackTabUrl = authView.getGoodDataUrlForSeriesReport($scope.currentTab.seriesId);

    $scope.trackTabClick = function () {
      trackingService.trackEvent(
        trackingService.pages.seriesDashboard.name,
        trackingService.pages.seriesDashboard.actions.viewGoodDataCourseReport);
    };

    $scope.$on('$locationChangeStart', function () {
      notificationService.clearNotification();
    });

    $scope.showFeatures = function () {
      accountInfoService.openNewWindow();
    };

    refreshSession.refresh();
  }

  function tabUtil() {

    function findWhere(arr, byName) {
      return _.find(arr, function (item) {
        return item.name == byName;
      });
      // DO NOT use findWhere atm because of yammer issues
//      return _.findWhere(arr, {name: byName});
    }

    return {
      getTab: function (byName, tabs) {
        var foundTab = _.find(tabs, function (tab) {
          return tab.name == byName || findWhere(tab.subSelection, byName);
        });

        if (!foundTab) return null;
        if (foundTab.name == byName)
          return foundTab;
        return findWhere(foundTab.subSelection, byName);
      },

      selectTab: function (byTab, tabs) {
        var byName = byTab.name;
        _.each(tabs, function (tab) {
          tab.selected = tab.name == byName || !!findWhere(tab.subSelection, byName);
        });
      }
    };
  }

})();
